<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>{{ title }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="OLT Name*"
                      v-model="form.oltName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="OLT IP*"
                      v-model="form.oltIp"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="Frame*"
                      v-model="form.frame"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="Slot*"
                      v-model="form.slot"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="mt-0 pt-0">
                    <v-text-field
                      label="Port*"
                      v-model="form.port"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="8" class="mt-0 pt-0">
                    <v-text-field
                      label="ONU ID"
                      v-model="form.onuId"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="ONU Type"
                      v-model="form.onuType"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="Type"
                      v-model="form.type"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>

              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onUpdate()"
                class="px-10"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "OnuIdUpdate",
  components: {
    Snackbar,
  },
  data() {
    return {
      dispatchStatus: [],
      assignToList: [],

      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      search: "",
      title: "",

      form: {
        onuId: "",
        oltName: "",
        oltIp: "",
        frame: "",
        slot: "",
        port: "",
        onuType: "",
        type: ""
      },
    };
  },

  methods: {
    open(data, title = "Change NAP") {
      this.dialog = true;
      this.title = title;

      this.selectedData = data;
      this.form.onuId = data.onuId;

      const form = { ...this.form };

      for (let [key] of Object.entries(form)) {
        console.log(key);

        this.form[key] = data[key];
      }
      //
      // setTimeout(() => {
      //   this.table.data = data;
      //   this.table.loading = false;
      // }, 500);
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      // this.$refs.form.reset();
      this.dialog = false;
    },

    async onUpdate() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = { ...this.form };
      data._id = this.selectedData._id;

      await this.$api
        .put("/tech/search-serial", data)
        .then((response) => {
          const res = response.data;

          this.loadingBtn = false;
          this.$refs.form.reset();

          console.log(res);

          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            this.loadingBtn = false;
            return;
          }

          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.agree();
          return;
        })
        .catch((e) => {
          console.log(e);
          // this.$emit("response", {
          //   status: false,
          //   message: e,
          // });
          this.loadingBtn = false;
        });
    },
  },

  created() {},
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
